// extracted by mini-css-extract-plugin
module.exports = {"button":"SearchButton_button__lVLBi"};